// extracted by mini-css-extract-plugin
export default {"bg":"HomeLoan_bg__N6FWu","container":"HomeLoan_container__JXj9f","left":"HomeLoan_left__p9TXB","right":"HomeLoan_right__shGB5"};